<script setup>
import { useDisplay } from "vuetify";

definePage({
  name: "BaseMobileBattle",
  path: "/base/mobile-battles",
  meta: {
    layout: "default",
    requiresAuth: true,
    title: "Battles",
    description: "Engage in Nexus battles and manage your mechs on the go.",
  },
});

const authStore = useAuthStore();
const router = useRouter();
const { mobile } = useDisplay();

// Redirect to desktop version on desktop devices
onMounted(() => {
  if (!mobile.value) {
    router.replace("/base");
  }
});

const commsBlockRef = ref();
const createMomentBtnRef = ref();

const bottomValue = ref("100px"); // Higher on mobile to account for bottom nav

const reloadComms = async () => {
  commsBlockRef.value.reloadComms();
};

const updateChildPosition = () => {
  nextTick(() => {
    const bottomNav = document.querySelector(".v-bottom-navigation");
    const btn = createMomentBtnRef.value;
    if (!bottomNav || !btn) return;

    const bottomNavRect = bottomNav.getBoundingClientRect();
    const windowHeight = window.innerHeight;

    if (bottomNavRect.top < windowHeight) {
      const overlap = windowHeight - bottomNavRect.top;
      bottomValue.value = `${overlap + 20}px`;
    } else {
      bottomValue.value = "80px";
    }
  });
};

onMounted(async () => {
  await nextTick();
  updateChildPosition();

  window.addEventListener("resize", updateChildPosition);
  window.addEventListener("scroll", updateChildPosition);
});

onUnmounted(() => {
  window.removeEventListener("resize", updateChildPosition);
  window.removeEventListener("scroll", updateChildPosition);
});
</script>

<template>
  <!-- StarrySky as fixed background -->
  <StarrySky class="" />

  <div class="tw-page-container tw-min-h-screen tw-relative tw-z-10">
    <v-container>
      <div
        class="tw-grid tw-grid-cols-1 lg:tw-grid-cols-2 xl:tw-grid-cols-[9fr_11fr] tw-gap-4"
      >
        <div
          class="tw-gap-4 tw-relative tw-overflow-hidden"
          ref="parentCommsBlockRef"
        >
          <mobile-battle-block class="tw-mb-4" />
        </div>
      </div>
    </v-container>
  </div>
</template>

<style>
.btn-create-moment {
  right: 16px;
  bottom: var(--bottom-value);
}

/* Mobile specific styles */
.tw-mobile-page-content {
  padding: 16px 0;
}

/* Ensure content is visible above the starfield */
.tw-page-container {
  background-color: transparent;
}
</style>
